import { Navigate, Route, Routes } from 'react-router';
import { AisHiddenRoute } from './ais/AisHiddenRoute.tsx';
import { LaunchOnlyRoute } from './ais/LaunchOnlyRoute.tsx';
import { PrivateRoute } from './components/PrivateRoute';
import { NoAccessRoute } from './NoAccessRoute';
import { Role } from './utils/user';
import { AiSettings } from './views/admin/AiSettings.tsx';
import { DbToolImport } from './views/admin/DbToolImport';
import { Doctors } from './views/admin/Doctors';
import { Insurances } from './views/admin/Insurances';
import { Lab } from './views/admin/Lab';
import { Labs } from './views/admin/Labs';
import { SystemStatus } from './views/admin/SystemStatus.tsx';
import { Themes } from './views/admin/Themes.tsx';
import { Users } from './views/admin/Users';
import { CreateFrontDeskDoctor } from './views/CreateFrontDeskDoctor.tsx';
import { CsvImport } from './views/CsvImport.tsx';
import { Dashboard } from './views/Dashboard';
import { DoctorSearch } from './views/DoctorSearch.tsx';
import { FibuExport } from './views/FibuExport.tsx';
import { FrontDeskOverview } from './views/FrontDeskOverview.tsx';
import { NewRequest } from './views/NewRequest';
import { OpenFrontDeskRequests } from './views/OpenFrontDeskRequests.tsx';
import { OpenRequests } from './views/OpenRequests';
import { PatientSearch } from './views/PatientSearch';
import { ParameterSelection } from './views/request/ParameterSelection';
import { PatientRegistration } from './views/request/PatientRegistration';
import { RequestSummary } from './views/request/RequestSummary';
import SampleCollection from './views/SampleCollection.tsx';
import { SentRequests } from './views/SentRequests';
import { Doctor } from './views/settings/Doctor.tsx';
import { Ecard } from './views/settings/Ecard.tsx';
import { LabAdminLab } from './views/settings/lab-admin/LabAdminLab.tsx';
import { Profiles } from './views/settings/Profiles';
import { Sheets } from './views/settings/Sheets.tsx';

export const AppRoutes = () => (
  <Routes>
    <Route element={<PrivateRoute />}>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route
        path="/zuweiserauswahl"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_FRONT_DESK]}>
            <DoctorSearch />
          </PrivateRoute>
        }
      />
      <Route
        path="/zuweiserauswahl/create"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_FRONT_DESK]}>
            <CreateFrontDeskDoctor />
          </PrivateRoute>
        }
      />
      <Route
        path="/anforderung"
        element={
          <LaunchOnlyRoute>
            <NewRequest />
          </LaunchOnlyRoute>
        }
      />
      <Route
        path="/anforderung/patient-erfassung"
        element={
          <LaunchOnlyRoute workflow>
            <PatientRegistration />
          </LaunchOnlyRoute>
        }
      />
      <Route
        path="/anforderung/parameterauswahl"
        element={
          <LaunchOnlyRoute workflow>
            <ParameterSelection />
          </LaunchOnlyRoute>
        }
      />
      <Route
        path="/anforderung/uebersicht"
        element={
          <LaunchOnlyRoute workflow>
            <RequestSummary />
          </LaunchOnlyRoute>
        }
      />
      <Route path="/offene-anforderungen" element={<OpenRequests />} />
      <Route
        path="/offene-anforderungen/csv-import"
        element={
          <LaunchOnlyRoute>
            <CsvImport />
          </LaunchOnlyRoute>
        }
      />
      <Route path="/gesendete-anforderungen" element={<SentRequests />} />
      <Route
        path="/patient-suche"
        element={
          <AisHiddenRoute>
            <PatientSearch showNewButton={false} />
          </AisHiddenRoute>
        }
      />
      <Route
        path="/pv-uebersicht"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_FRONT_DESK]}>
            <FrontDeskOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/probenannahme"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_LAB_STAFF]}>
            <SampleCollection />
          </PrivateRoute>
        }
      />
      <Route
        path="/alle-offenen-pv-anforderungen"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_FRONT_DESK]}>
            <OpenFrontDeskRequests />
          </PrivateRoute>
        }
      />
      <Route
        path="/fibu-export"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_LAB_ADMIN, Role.ROLE_LR_FRONT_DESK]}>
            <FibuExport />
          </PrivateRoute>
        }
      />
      <Route
        path="/einstellungen/zuweiser"
        element={
          <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_LAB_ADMIN, Role.ROLE_LR_USER]}>
            <Doctor />
          </PrivateRoute>
        }
      />
      <Route path="/einstellungen/profile" element={<Profiles />} />
      <Route path="/einstellungen/sheets" element={<Sheets />} />
      <Route
        path="/einstellungen/ecard"
        element={
          <AisHiddenRoute>
            <Ecard />
          </AisHiddenRoute>
        }
      />
      <Route path="/labadmin/*">
        <Route
          path="*"
          element={
            <PrivateRoute roles={[Role.ROLE_LR_MEDCOM, Role.ROLE_LR_LAB_ADMIN]}>
              <LabAdminLab />
            </PrivateRoute>
          }
        />
      </Route>
    </Route>
    <Route element={<PrivateRoute roles={[Role.ROLE_LR_MEDCOM]} />}>
      <Route path="/admin/themes" element={<Themes />} />
      <Route path="/admin/benutzer" element={<Users />} />
      <Route path="/admin/zuweiser" element={<Doctors />} />
      <Route path="/admin/krankenkassen" element={<Insurances />} />
      <Route path="/admin/db-tool-import" element={<DbToolImport />} />
      <Route path="/admin/system-status" element={<SystemStatus />} />
      <Route path="/admin/ai-konfiguration" element={<AiSettings />} />
      <Route path="/admin/labors" element={<Labs />} />
      <Route path="/admin/labors/:id/*">
        <Route path="*" element={<Lab />} />
      </Route>
    </Route>
    <Route path="/no-access" element={<NoAccessRoute />} />
    <Route path="*" element={<Navigate replace to="/dashboard" />} />
  </Routes>
);
